import { createUseStyles } from 'react-jss'
import hexToRgba from '../../helpers/hex-to-rgba'

const useStyles = createUseStyles((theme) => ({
  modal: {
    backgroundColor: 'transparent',
    padding: 0,
    margin: '0 auto',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'stretch',
    top: 'auto',
    maxHeight: '99dvh',
    fallbacks: {
      maxHeight: '92vh',
    },
    maxWidth: `${theme.mediaQueries.tablet}px`,
    overflow: 'hidden',
    [`@media (min-width: ${theme.mediaQueries.tablet}px)`]: {
      maxHeight: '90vh',
      bottom: '5vh',
    },
  },
  dialogContainer: {
    backgroundColor: theme.colors.background,
    flexShrink: 1,
    flexGrow: 0,
    overflow: 'hidden',
    borderTopLeftRadius: '0.8rem',
    borderTopRightRadius: '0.8rem',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'stretch',

    maxHeight: 0,
    transform: 'translateY(100%)',
    transition: 'transform 200ms ease-in-out',
  },
  dialogContainerActive: {
    maxHeight: 'none',
    transform: 'translateY(0%)',
  },
  dialogHeader: {
    flexShrink: 0,
    position: 'relative',
    minHeight: '4.8rem',
  },
  closeButton: {
    padding: '1rem',
    marginRight: '-1rem',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
  },
  closeButtonIcon: {
    width: '1.4rem',
    height: '1.4rem',
  },
  dialogBody: {
    paddingBottom: '3rem',
    flexShrink: 1,
    flexGrow: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  dialogTitle: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    lineHeight: 1.333,
    marginBottom: '3rem',
  },
  dialogDescription: {
    fontSize: '1.6rem',
    lineHeight: 1.25,
    marginBottom: '2rem',
  },
  dialogFooter: {
    overflow: 'hidden',
    backgroundColor: theme.colors.background,
    boxShadow: '0rem 0rem 0rem rgba(0, 0, 0, 0)',
    padding: '1.2rem 1.6rem',
    flexShrink: 0,
    zIndex: 10,

    display: 'flex',
    justifyContent: 'space-between',
    gap: '1.6rem',
    alignItems: 'center',
    transition: 'box-shadow 1s',
    [`@media (min-width: ${theme.mediaQueries.tablet}px)`]: {
      borderBottomLeftRadius: '0.8rem',
      borderBottomRightRadius: '0.8rem',
    },
  },
  dialogFooterWithShadow: {
    boxShadow: '0rem -0.5rem 0.5rem rgba(0, 0, 0, 0.1)',
  },
  // dialogButtons: {
  //   maxWidth: '33.8rem',
  //   marginLeft: 'auto',
  //   marginRight: 'auto',
  //   marginBottom: '-1.6rem',
  // },
  productQuantity: {
    flexBasis: '80%',
  },
  button: {
    marginBottom: 0,
    backgroundColor: theme.config.ui.buttons.addToCart.active.backgroundColor,
    border: theme.config.ui.buttons.addToCart.active.border,
  },

  // product details
  upperContent: {
    padding: '0 0 1.6rem',
    gap: '1rem',
    flex: 1,
    display: 'flex',
    flexDirection: 'var(--ui-product-quick-add-modal-flex-direction)',
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  link: {
    textDecoration: 'none',
    flexGrow: 1,
  },
  figure: {
    position: 'relative',
    margin: 0,
    width: '100%',
    flexShrink: 0,

    flexBasis: 'var(--ui-product-quick-add-modal-thumbnail-width)',
    maxWidth: 'var(--ui-product-quick-add-modal-thumbnail-max-width)',
  },
  favouriteButton: {
    position: 'absolute',
    zIndex: 1,
    top: '0.6rem',
    right: '0.6rem',
  },
  icon: {
    position: 'absolute',
    right: '1.3rem',
    top: '1.3rem',
    cursor: 'pointer',
    maxWidth: '1.8rem',
  },
  image: {
    aspectRatio: 'var(--ui-product-quick-add-modal-image-aspect-ratio)',
    borderRadius: 'var(--ui-product-quick-add-modal-image-border-radius)',
    overflow: 'hidden',
    objectFit: 'cover',
    objectPosition: 'center center',
    width: '100%',
    height: '100%',
    margin: 0,
  },
  noImage: {
    backgroundColor: '#f1f1f1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    objectFit: 'contain',
  },
  content: {
    color: theme.colors.text,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    textAlign: 'var(--ui-product-quick-add-modal-content-text-align)',
    padding: '0 1.6rem',
  },
  contentText: {
    marginBottom: '0.2rem',
    fontSize: '1.4rem',
    lineHeight: '1.42em',
  },
  title: {
    fontSize: '1.6rem',
    fontWeight: 'bold',
    wordBreak: 'break-word',
  },
  details: {
    // display: 'none',
    display: 'var(--ui-product-quick-add-modal-content-details-display)',
    // '-webkit-box-orient': 'vertical',
    // '-webkit-line-clamp': 2,
    overflow: 'hidden',
    color: theme.colors.bgMediumDark,
  },
  customLabelsContainer: {
    minHeight: '2rem',
    marginBottom: '0.8rem',
    marginTop: '1rem',
    '&:empty': {
      display: 'none',
    },
  },
  customLabels: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'var(--ui-product-quick-add-modal-custom-labels-justify-content)',
    alignItems: 'baseline',
  },
  colorSelect: {
    color: theme.colors.disabled,
  },
  variantTitle: {
    marginTop: `${theme.gap}rem`,
    textTransform: 'uppercase',
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: '1rem',
  },
  colorStyle: {
    display: 'block',
    height: '5.2rem',
    cursor: 'pointer',
    borderWidth: '0.1rem',
    borderStyle: 'solid',
    '&.select': {
      borderColor: theme.colors.secondary,
    },
  },
  sizeStyle: {
    minHeight: '3.6rem',
    minWidth: '5.1rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    fontSize: '1.4rem',
    fontWeight: 600,
    textAlign: 'center',
    lineHeight: 2.5,
    borderWidth: '0.1rem',
    borderStyle: 'solid',
    borderColor: theme.colors.bgDark,
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      background: theme.colors.bgDark,
      borderColor: theme.colors.bgDark,
    },
  },
  sizeSelectedStyle: {
    borderColor: theme.colors.secondary,
    background: hexToRgba(theme.colors.secondary, 0.5),
    '&:hover': {
      borderColor: theme.colors.secondary,
      background: hexToRgba(theme.colors.secondary, 0.5),
    },
  },
  sizeOutOfStock: {
    backgroundColor: hexToRgba(theme.colors.disabled, 0.2),
    '&:hover': {
      // background: theme.colors.background,
      borderColor: theme.colors.bgMediumDark,
    },
  },
  optionsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '1.5rem',
  },
  optionsItem: {
    minWidth: '4.8rem',
  },
  priceContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'var(--ui-product-quick-add-modal-price-container-justify-content)',
  },
  price: {
    fontSize: 'var(--ui-product-quick-add-modal-price-font-size)',
    justifyContent: 'var(--ui-product-quick-add-modal-price-list-justify-content)',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
  },
  backInStockNotificationButton: {
    backgroundColor: theme.colors.bgMedium,
    borderColor: theme.colors.bgMedium,
  },
  backInStockNotificationButtonIcon: {
    margin: [[0, '0.4rem']],
  },
  backInStockNotificationButtonDisabled: {
    opacity: 0.5,
  },
}))

export default useStyles
